// extracted by mini-css-extract-plugin
export default {"pagination":"Pagination_pagination__70FO-","dark":"Pagination_dark__rSDfK","control":"Pagination_control__ECoVy","inp":"Pagination_inp__cTufE","keys":"Pagination_keys__2-uxB"};